import { SettingConst } from '../../types';

/**
 * Controls whether filter buttons are triggered by onMouseDown or onClick
 */
export const ENABLE_ON_MOUSE_DOWN_FOR_FILTER_BUTTONS_250122 =
  'ENABLE_ON_MOUSE_DOWN_FOR_FILTER_BUTTONS_250122' as SettingConst<
    'ENABLE_ON_MOUSE_DOWN_FOR_FILTER_BUTTONS_250122',
    boolean,
    'RETAILER' | 'RETAILER_HEAD_TAGS'
  >;
